import { createStore } from 'zustand';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { devtools } from 'zustand/middleware';
import {
  CurrentUserSlice,
  createCurrentUserSlice,
  getCurrentUserFeatures,
  User,
} from './currentUser';
import { BunkerExSlice, createBunkerExSlice } from './bunkerEx';
import { CurrencyRatesSlice, createCurrencyRateSlices } from './currencyRates';

export type GlobalStore = BunkerExSlice & CurrentUserSlice & CurrencyRatesSlice;

export const globalStore = createStore<GlobalStore>()(
  devtools((setState, getState, store) => {
    return {
      ...createCurrentUserSlice(setState, getState, store),
      ...createCurrencyRateSlices(setState, getState, store),
      ...createBunkerExSlice(setState, getState, store),
    };
  }),
);

export const useGlobalStore = <T>(
  selector: (state: GlobalStore) => T,
  equals?: (a: T, b: T) => boolean,
) => useStoreWithEqualityFn(globalStore, selector, equals);

/**
 *  Set initial values for the global store
 */
export function setInitialValues(currentUser?: User) {
  const defaultCurrency =
    currentUser?.organization?.defaultCurrency ??
    currentUser?.rootOrganization?.defaultCurrency;

  const features = currentUser ? getCurrentUserFeatures(currentUser) : [];

  globalStore.setState({
    currentUser,
    features,
    ...(defaultCurrency && { defaultCurrency }),
  });
}

/**
 *  Set initial values for the global store
 */
export function setUser(user: User) {
  const defaultCurrency =
    user.organization?.defaultCurrency ??
    user.rootOrganization?.defaultCurrency;

  globalStore.setState({
    currentUser: user,
    features: getCurrentUserFeatures(user),
    ...(defaultCurrency && { defaultCurrency }),
  });
}
